import { Injectable } from "@angular/core";
import LoggerService from "@bfx/logger";
import { TranslateService } from "@ngx-translate/core";
import { ErrorsImpl } from "shared/cubiq-model-multi-asset";
const logger = LoggerService.for(__dirname);

/**
 * Type used to return translation and components of a single server Error
 */
export type ServerErrorDetail = {
  errorId: string;
  errorArgs: any[];
  errorMessage: string;
};

/**
 * Utility service to streamline the translation and management of incoming server errors.
 */
@Injectable()
export class BfxErrorHandlingService {
  constructor(private translate: TranslateService) {}

  /**
   * Translate all errors in Erros object and return as array of
   * individual message
   * @param errors
   * @returns Array of string - will be empty if no errors found
   */
  public getErrorMessages(errors: ErrorsImpl): string[] {
    const retMessages = [];
    if (errors?.errorMessages?.length > 0) {
      this.convertErrorsToStrArray(errors.errorMessages as any[], retMessages);
    }
    return retMessages;
  }

  public getErrorDetails(errors: ErrorsImpl): ServerErrorDetail[] {
    const retModels = [];
    if (errors?.errorMessages?.length > 0) {
      this.convertErrorsToModelArray(errors.errorMessages as any[], retModels);
    }
    return retModels;
  }

  /**
   * Creates a translation object with a message as id and
   * parameters as args list from a string
   * @param error the error string as served in ErrorsImpl object - a json str
   * @param translations container for translated strings
   */
  private convertErrorsToStrArray(errors: string[], translations: string[]) {
    errors
      .map((e) => JSON.parse(e))
      .forEach((errMessage) => {
        const id: string = errMessage["id"];
        const args: any[] = errMessage["args"];
        if (id && id.length > 0) {
          translations.push(this.translate.instant(id, args));
        } else {
          logger.out.warn(`eh-s - Cannot find error Id in json: ${errMessage.toString()}`);
        }
      });
  }

  /**
   * Creates a translation object with a message as id and
   * parameters as args list from a string
   * @param error the error string as served in ErrorsImpl object - a json str
   * @param translations container for error models
   */
  private convertErrorsToModelArray(errors: string[], translations: ServerErrorDetail[]) {
    errors
      .map((e) => JSON.parse(e))
      .forEach((errMessage) => {
        const id: string = errMessage["id"];
        const args: any[] = errMessage["args"];
        if (id && id.length > 0) {
          translations.push({
            errorId: id,
            errorArgs: args,
            errorMessage: this.translate.instant(id, args),
          });
        } else {
          logger.out.warn(
            `eh-s - Cannot find error Id in json converting to models: ${errMessage.toString()}`,
          );
        }
      });
  }
}
